export const STAFF_INVOICE_ACTIVITY_ACTION_TYPES = [
  {
    id: 'POSTED',
    name: 'Posted',
  },
  {
    id: 'PAID',
    name: 'Paid',
  },
];
